import {Pipe, PipeTransform} from '@angular/core'

@Pipe({name: 'numberSpaced'})
export class NumberSpacedPipe implements PipeTransform {
  transform(value: number, args?: any): string {
    return value.toString().replace(/(?!^)(?=(?:\d{3})+$)/g, ' ');
  }
}